<template>
  <div :id="section.anchorLinkId" class="px-4 py-8" data-testid="articleSection" :class="[backgroundColor, section.anchorLinkId && 'scroll-mt-20']">
    <div class="w-full md:mx-auto md:max-w-[1136px]" data-testid="article">
      <div :class="[section.reverseOrder && 'flex-col-reverse', 'flex w-full flex-col md:flex-row md:gap-x-4']">
        <div v-for="column in section.columns" :key="column.fieldId" class="md:w-0 md:flex-1">
          <ArticleColumn
            :column="column"
            :experiences="experiences"
            :multi-column-layout="multiColumnLayout"
            :on-cta-link-click="onCtaLinkClick"
            :on-drawer-link-click="onDrawerLinkClick"
            :show-drawer-link="showDrawerLink"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type ArticleSection } from '@/wabunka-src/common/features';
import ArticleColumn from '@/wabunka-src/common/features/Featured/components/ArticleColumn/ArticleColumn.vue';
import { ThemeKey } from '@/wabunka-src/common/features/Featured/injectionKeys';
import type { ExperienceListViewModel } from '@/wabunka-src/features/Experience';

const props = withDefaults(
  defineProps<{
    section: ArticleSection;
    experiences: ExperienceListViewModel;
    isBgBeige?: boolean;
    /**
     * CTA ボタンクリック時に呼ばれる。true を返すと遷移を行わない。親でリンク先に応じた処理（例: ドロワーを開く）に使う。
     */
    onCtaLinkClick?: (link: string) => boolean;
    /**
     * drawerLink を描画するか。表示可能なドロワータブが無いページでは false（ADR-145 / D-005）。
     */
    showDrawerLink?: boolean;
    /**
     * drawerLink クリック時に呼ばれる。開くタブのキーと、押されたリンクのラベルを親へ渡す。
     */
    onDrawerLinkClick?: (tabKey: string, label: string) => void;
  }>(),
  { onCtaLinkClick: undefined, showDrawerLink: false, onDrawerLinkClick: undefined },
);

const multiColumnLayout = computed<boolean>(() => props.section.columns.length > 1);

const backgroundColor = computed(() => {
  switch (props.section.backgroundColor?.[0]) {
    case '白':
      return 'bg-light-bg-default';
    case 'ベージュ':
      return 'bg-light-bg-inset';
    case '深紫':
      return 'bg-dark-bg-default';
    default:
      return props.isBgBeige ? 'bg-light-bg-inset' : 'bg-light-bg-default';
  }
});

const theme = computed<'light' | 'dark'>(() => {
  return backgroundColor.value === 'bg-dark-bg-default' ? 'dark' : 'light';
});

provide(ThemeKey, theme);
</script>
